import { useEffect, useRef, useState } from 'react';
import { useInViewOnce } from '../../hooks/useInViewOnce';
import Testimonials from './Testimonials';

export default function DeferredTestimonials() {
  const anchorRef = useRef<HTMLDivElement>(null);
  const nearViewport = useInViewOnce(anchorRef, { once: true, margin: '240px' });
  
  // false for both SSR and initial hydration to reduce DOM size.
  // Will only render when user scrolls near it.
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (nearViewport) setShow(true);
  }, [nearViewport]);

  return (
    <div ref={anchorRef} className="deferred-testimonials-wrapper">
      {show ? (
        <Testimonials />
      ) : (
        <div style={{ minHeight: '600px' }} aria-hidden="true" />
      )}
    </div>
  );
}

